import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import SVG from 'react-inlinesvg';
import { Link as SpyLink } from 'react-scroll';

import background from 'assets/images/work/banner-background.svg';

import { Section, SectionHeader, Button } from 'components';

import './Banner.scss';

const Banner = () => {
  const statistics = Banner.STATISTICS.map((stat, i) => (
    <>
      <Col xs={12} md={3} className="anim-fade-in-bottom">
        <div className="work-banner-content__statistics-wrapper">
          <div className="work-banner-content__statistics-number">
            {stat.value}
          </div>
          <div className="work-banner-content__statistics-label">
            {stat.name}
          </div>
        </div>
      </Col>

      {i < Banner.STATISTICS.length - 1 && (
        <Col xs={12} md>
          <div className="work-banner-content__statistics-separator" />
        </Col>
      )}
    </>
  ));

  const mapPoints = Banner.MAP_POINTS.map((point, i) => (
    <div
      // eslint-disable-next-line react/no-array-index-key
      key={i}
      className="work-banner-background__point"
      style={{ ...point }}
    />
  ));

  return (
    <Section color={'carrara'} additionalClass={`work-banner`}>
      <div className="work-banner-background">
        <SVG src={background} className="work-banner-background__image" />
        <div className="work-banner-background__points">{mapPoints}</div>
      </div>
      <div className="work-banner-content">
        <SectionHeader color={'black'} lineColor={'black'} size={'large'}>
          <span>Work</span>
        </SectionHeader>
        <Row className="work-banner-content__statistics">{statistics}</Row>
        <SpyLink
          id={'work__go-to-content'}
          to={'case-studies'}
          spy={false}
          smooth
          duration={500}
          className="work-banner-content__discover"
        >
          <Button id="work-banner-discover-button" color="transparent">
            Discover our work
          </Button>
        </SpyLink>
      </div>
    </Section>
  );
};

Banner.STATISTICS = [
  {
    name: (
      <>
        digital product
        <br />
        answering
        <br />
        varied needs
      </>
    ),
    value: 250,
  },
  {
    name: (
      <>
        clients from all
        <br />
        over the world
      </>
    ),
    value: 90,
  },
  {
    name: (
      <>
        years in
        <br />
        business
      </>
    ),
    value: 15,
  },
];

Banner.MAP_POINTS = [
  // USA
  { left: '25%', top: '32%' },
  { left: '14%', top: '25%' },
  { left: '21%', top: '40%' },

  // Saudi
  { left: '62%', top: '51%' },
  { left: '59%', top: '47%' },

  // Europe
  { left: '45%', top: '38%' },
  { left: '46%', top: '29%' },
  { left: '49%', top: '22%' },
  { left: '52%', top: '17%' },
  { left: '56%', top: '39%' },
  { left: '51%', top: '35%' },
  { left: '53%', top: '33%' },
  { left: '54%', top: '28%' },
  { left: '52%', top: '30%' },
  { left: '55%', top: '31.5%' },

  // Asia
  { left: '75%', top: '50%' },

  // Australia
  { left: '82%', top: '77%' },
];

export default Banner;
